import makeWebSocketObservable from "rxjs-websockets";

export class RxjsWebsocketWrapper {
  static makeWebSocketObservable = makeWebSocketObservable;
}
